import { fetchYooFindsApi } from "@/utils/fetch";
import { getUri } from "@/utils/url";
import {
  ResponseData,
  ListResponse,
  TProductDetail,
  TShopDetail,
  TProductRelatedCreator,
  TProductRelatedVideo,
  TProductRelatedLive,
  TProductTrendInfo,
  TSkuInfo,
  THomeCategoryList,
  TProductActiveData,
  TDetailRelatedProducts,
} from "@/typings";
import {
  GetProductRelatedThingsParams,
  GetProductTrendsParams,
  GetHomeProductListAllParams,
  GetDetailProductListParams,
} from "./interface";

export function fetchProductDetail(productId: string) {
  return fetchYooFindsApi<ResponseData<TProductDetail>>(
    `api/campaign-products/${productId}`
  );
}

export function fetchShopDetail(shopId: string) {
  return fetchYooFindsApi<ResponseData<TShopDetail>>(`api/shops/${shopId}`);
}

export function fetchProductRelatedCreators(
  params: GetProductRelatedThingsParams
) {
  return fetchYooFindsApi<ResponseData<ListResponse<TProductRelatedCreator>>>(
    getUri(`api/v10/products/${params.product_id}/creators`, {
      page: params.page,
      page_size: params.page_size,
      sort_column: "product_sales_count",
      order_by: "desc",
    })
  );
}

export function fetchProductRelatedVideos(
  params: GetProductRelatedThingsParams
) {
  return fetchYooFindsApi<ResponseData<ListResponse<TProductRelatedVideo>>>(
    getUri(`api/v10/products/${params.product_id}/videos`, {
      page: params.page,
      page_size: params.page_size,
      sort_column: "product_sales_amount",
      order_by: "desc",
    })
  );
}

export function fetchProductRelatedLives(
  params: GetProductRelatedThingsParams
) {
  return fetchYooFindsApi<ResponseData<ListResponse<TProductRelatedLive>>>(
    getUri(`api/v10/products/${params.product_id}/lives`, {
      page: params.page,
      page_size: params.page_size,
      sort_column: "live_create_time",
      order_by: "desc",
    })
  );
}

export function fetchProductTrends(params: GetProductTrendsParams) {
  return fetchYooFindsApi<ResponseData<TProductTrendInfo[]>>(
    getUri(`api/products/${params.product_id}/trends`, {
      date_type: params.date_type,
    })
  );
}

export function fetchProductSkus(productId: string) {
  return fetchYooFindsApi<ResponseData<TSkuInfo>>(
    `api/products/${productId}/skus`
  );
}

export function fetchHomeFilterList() {
  return fetchYooFindsApi<ResponseData<THomeCategoryList>>(
    "api/v10/home/filterList"
  );
}

export function fetchHomeProductListAll(params: GetHomeProductListAllParams) {
  return fetchYooFindsApi<ResponseData<TProductActiveData>>(
    getUri(`api/v3/products/recommend`, params)
  );
}

export function fetchHomeProductList(params: GetHomeProductListAllParams) {
  return fetchYooFindsApi<ResponseData<TProductActiveData>>(
    getUri(`api/v2/products/recommend/${params.type}`, params)
  );
}

export function fetchDetailRelatedProducts(params: GetDetailProductListParams) {
  return fetchYooFindsApi<ResponseData<TDetailRelatedProducts>>(
    getUri("api/v10/recommend/detailRecommend", params)
  );
}
